import {useState} from 'react'
import AutoApprovalForm from './AutoApprovalForm';
import AutoApprovalList from './AutoApprovalList';

const AutoApproval = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AutoApprovalForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AutoApprovalList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}
export default AutoApproval